import CornerBrackets from "./CornerBrackets";

const PassportFrame = ({ isOk }) => {
  const c = isOk ? "rgba(96,165,250,0.7)" : "rgba(255,255,255,0.35)";
  const cs = isOk ? "rgba(96,165,250,0.9)" : "rgba(255,255,255,0.6)";

  return (
    <div
      className="absolute inset-0 flex justify-center items-center pointer-events-none"
      // Size container so the frame below can cap itself against this box's
      // height via cqh units.
      style={{ containerType: "size" }}
    >
      <div
        className="relative"
        style={{
          width: "90%",
          aspectRatio: "185 / 265",
          // On a landscape phone or desktop webcam, width:90% alone would
          // make the guide taller than the screen (passport is a portrait
          // shape). Capping the width (not the height) keeps the passport
          // shape: max-height would only clamp the height and leave the width
          // at 90%, stretching the guide into a wide rectangle. Width at this
          // cap gives a height of exactly 90cqh — mirrors
          // DOCUMENT_FRAME_SPEC.PASSPORT.maxHeightFraction, which the
          // auto-capture check uses. Browsers without container query units
          // drop this line and fall back to the uncapped 90% width.
          maxWidth: "calc(90cqh * 185 / 265)",
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.55)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 175 265"
          fill="none"
          preserveAspectRatio="xMidYMid meet"
        >
          {/* Photo area — bottom-left */}
          <rect x="42" y="200" width="64" height="52" rx="3" stroke={cs} strokeWidth="1.5" fill={c} fillOpacity="0.15" />
          <circle cx="74" cy="216" r="9" stroke={cs} strokeWidth="1.5" />
          <path d="M57 252C61 242 87 242 91 252" stroke={cs} strokeWidth="1.5" strokeLinecap="round" />

          {/* Vertical data bars — centre */}
          {[
            { x: 44, h: 175 }, { x: 55, h: 110 }, { x: 65, h: 175 },
            { x: 75, h: 85 },  { x: 85, h: 130 }, { x: 95, h: 100 },
          ].map(({ x, h }, i) => (
            <rect key={i} x={x} y={14} width="5" height={h} rx="2.5" fill={c} />
          ))}

          {/* MRZ columns — right side */}
          {[144, 158].map((x) =>
            Array.from({ length: 17 }).map((_, row) => (
              <rect key={`${x}-${row}`} x={x} y={14 + row * 14} width="8" height="9" rx="1.5" fill={c} />
            ))
          )}
        </svg>

        <div className="absolute inset-0">
          <CornerBrackets isOk={isOk} />
        </div>
      </div>
    </div>
  );
};

export default PassportFrame;
